export default ({ request }) => ({
  mrpOutsourcingStockOutListApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockOut/list',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockOutDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockOut/detail',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockOutSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockOut/save',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockOutDelApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockOut/del',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockOutSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockOut/submit',
      method: 'post',
      data,
    })
  },
})
